import { Col, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router";
import "./Radar.scss";
import { useMemo } from "react";

const informationByLanguage = {
  pt: {
    tutorialUrl:
      "https://www.youtube.com/embed/-ybsf4i99WE?si=6Y-f3YVNbrS0ZvKS",
  },
  en: {
    tutorialUrl:
      "https://www.youtube.com/embed/hvzGBE0RPwA?si=6Y-f3YVNbrS0ZvKS",
  },
  es: {
    tutorialUrl:
      "https://www.youtube.com/embed/hvzGBE0RPwA?si=6Y-f3YVNbrS0ZvKS",
  },
};

const Radar: React.FC<RouteComponentProps> = () => {
  const { t, i18n } = useTranslation("radar");

  const { tutorialUrl } = useMemo(() => {
    const language = ["pt", "en", "es"].includes(i18n?.language)
      ? (i18n.language as keyof typeof informationByLanguage)
      : "pt";

    return informationByLanguage[language];
  }, [i18n.language]);

  return (
    <div className="radar" style={{ fontFamily: "Cabin", paddingTop: 32 }}>
      <Row justify="center">
        <Col xs={24}>
          <Row>
            <Col xs={24}>
              <Typography.Title
                className="texto-centralizado  texto-colorido"
                style={{ fontSize: 40, textTransform: "uppercase" }}
              >
                {t("pages.Radar.titulo")}
              </Typography.Title>
              <div
                className="explicacao texto-centralizado"
                style={{ fontSize: 25, fontWeight: "lighter" }}
              >
                <Typography.Text>{t("pages.Radar.mensagem")}</Typography.Text>
              </div>
              <div className="diagnostico-preview">
                <div className="preview-border">
                  <div className="preview-content">
                    <iframe
                      width="100%"
                      height="350"
                      style={{ border: "none" }}
                      src={tutorialUrl}
                      title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Radar;
